const capFirstLetter = (s: string) => s.charAt(0).toUpperCase() + s.slice(1)

/*
  null -- none
  john  --- single
  john and jane --- two
  john, jane, and jeb --- multi
 */

export const buildMultiElementListString = (
  list: string[],
  conjunction = "and",
  shouldCapsFirstLetter = true
): string | null => {
  if (list.length === 0) {
    return null
  }

  if (list.length === 1) {
    const sentence = list[0]
    return shouldCapsFirstLetter ? capFirstLetter(sentence) : sentence
  }

  if (list.length === 2) {
    const sentence = `${list[0]} ${conjunction} ${list[1]}`
    return shouldCapsFirstLetter ? capFirstLetter(sentence) : sentence
  }

  const allButLastElement = list.slice(0, list.length - 1)
  const lastElement = list[list.length - 1]

  const firstHalfResult = allButLastElement.map((e) => `${e},`).join(" ")
  const sentence = `${firstHalfResult} ${conjunction} ${lastElement}`
  return shouldCapsFirstLetter ? capFirstLetter(sentence) : sentence
}
